import { useState } from "react";

export const useFlowHubCarouselControls = (totalSlides: number) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const handleNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % totalSlides);
    };

    const handlePrevious = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + totalSlides) % totalSlides);
    };

    const goToSlide = (index: number) => {
        setCurrentIndex(index);
    };

    return {
        currentIndex,
        handleNext,
        handlePrevious,
        goToSlide,
    };
}